export const BANNER_FEE_UPDATE = 'platformBannerDismissed';
